/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {create} from 'zustand';

type UserStoreData = {
  userId: string | null;
  username: string | null;
  firstName: string | null;
  lastName: string | null;
  permissionsList: string[];
  permissionsMap: Record<string, boolean>;
};

type UserStoreMethods = {
  setUser: (userData: Partial<UserStoreData>) => void;
  resetUser: () => void;
};

type UserStore = UserStoreData & UserStoreMethods;

export const useUserStore = create<UserStore>((set) => ({
  userId: null,
  username: null,
  firstName: null,
  lastName: null,
  permissionsList: [],
  permissionsMap: {},
  setUser: (userData) => set((state) => ({...state, ...userData})),
  resetUser: () =>
    set({
      userId: null,
      username: null,
      firstName: null,
      lastName: null,
      permissionsList: [],
      permissionsMap: {},
    }),
}));
